module.exports = __webpack_public_path__ + "img/coin.7f95e394.svg";